import { motion } from 'framer-motion';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AddIcon, Button } from 'shared/components';

interface Props {
  onClick: VoidFunction;
}

export const ServiceListError: React.FC<Props> = ({ onClick }) => (
  <motion.div
    style={{
      opacity: 0,
      y: 8,
    }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1, delay: 0.2, type: 'spring' }}
    className="alert alert--note settings-itemlist__alert__container"
  >
    <div className="f f--col">
      <p className="s-bottom--sml text--xs__responsive t-text-1 t-bold">
        <FormattedMessage id="errors.services.header" />
      </p>
      <p className="text--xsm t-text-2">
        <FormattedMessage id="errors.services.description" />
      </p>
    </div>
    <Button
      type="button"
      onClick={onClick}
      style="secondary"
      size="med"
      className="u-fit--content"
      btnSelector="add-new-service"
    >
      <AddIcon />
      <FormattedMessage id="buttons.add-new-service" />
    </Button>
  </motion.div>
);
